export default function segmentSelect($stateParams, $state, $rootScope, API, UserCache) {
  'ngInject'
  var directive = {
    restrict: 'E',
    scope: {
      tags: '=tags',
      multiple: '=multiple',
    },
    template: '<input type="hidden" class="bigdrop" id="e15" style="width:400px;"/>',
    link: selectLink,
  }

  return directive

  function selectLink($scope, $element, $attr) {
    var auth = UserCache.getObject()
    $.ajaxSetup({
      headers: {
        'X-Collectible-Platform': 'QP2',
        Authorization: 'Bearer ' + auth.jwt,
      },
    })
    $('#e15').select2({
      ajax: {
        url: function (t, page) {
          var start, limit
          if (page === 1) {
            start = 0
            limit = 15
          } else {
            limit = page * 15
            start = limit - 15
          }
          return (
            API.API_URL + 'admin/user_segments/active?txt=' + t + '&start=' + start + '&limit=' + 15
          )
        },
        dataType: 'json',
        quietMillis: 250,
        data: function (t, page) {
          return {
            page: page,
            t: t,
          }
        },
        results: function (data, page) {
          $rootScope.$broadcast('segmentList', data.results)
          return {
            results: data.results,
            more: page + 15 < data.ct,
          }
        },
      },
      multiple: $scope.multiple,
      escapeMarkup: function (markup) {
        return markup
      }, // let our custom formatter work
      minimumInputLength: 1,
      formatResult: formatState,
      formatSelection: formatStateSelection,
    })

    function formatState(state) {
      if (state.loading) {
        return state.text
      }

      var markup =
        "<div class='select2-result-repository clearfix'>" +
        "<div class='select2-result-repository__meta'>" +
        "<div class='select2-result-repository__title'>" +
        "<div style='font-size: 12px; color: #333; opacity: 0.9;'>ID: " +
        state.id +
        '</div>' +
        '<div>' +
        state.t +
        '</div>' +
        '</div>' +
        '</div></div>'

      return markup
    }

    function formatStateSelection(state) {
      return state.t
    }
  }
}
